
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/term-of-use",
      function () {
        return require("private-next-pages/term-of-use.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/term-of-use"])
      });
    }
  